import { Tab, Tabs } from "@mui/material";
import { TabWrapper } from "../TabWrapper";
import { showNumber } from "../pricing/Pricing";
import { useProject } from "../ProjectName";
import { useAlternative } from "../../quote/alternative/Alternative";
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const defaultDiv10Tab = "wr-accessory";
export function Div10Tabs(props) { const proj = useProject(); const alt = useAlternative(); return /*#__PURE__*/ _jsx(TabWrapper, { children: /*#__PURE__*/ _jsx(Tabs, { value: props.tab, onChange: (e, value) => props.onChange(value), children: div10TabKeys.filter(k => { if (props.accessories === false)
            return k !== "wr-accessory"; return true; }).map(k => { var _props$unpriced; return /*#__PURE__*/ _jsx(Tab, { label: /*#__PURE__*/ _jsxs(_Fragment, { children: [showNumber(Div10TypeToName(k), (_props$unpriced = props.unpriced) === null || _props$unpriced === void 0 ? void 0 : _props$unpriced.div10Detail[k].unpriced), isLocked(k, proj, alt) ? " 🔒" : ""] }), value: k }, k); }) }) }); }
function isLocked(k, proj, alt) { if (!proj)
    return false; if (!alt)
    return false; if (k === "wr-accessory" && proj.quoteLockedDiv10WrAccessories === alt)
    return true; if (k === "wr-partition" && proj.quoteLockedDiv10WrPartitions === alt)
    return true; if (k === "locker" && proj.quoteLockedDiv10Lockers === alt)
    return true; if (k === "mailbox" && proj.quoteLockedDiv10Mailboxes === alt)
    return true; if (k === "corner-guard" && proj.quoteLockedDiv10CornerGuards === alt)
    return true; return false; }
export const div10TabKeys = ["wr-accessory", "wr-partition", "locker", "mailbox", "corner-guard"]; // keep in sync with product/main.go:Div10TypeToName
export function Div10TypeToName(input) { switch (input) {
    case "wr-accessory": return "W/R Accessories";
    case "wr-partition": return "W/R Partitions";
    case "locker": return "Lockers";
    case "mailbox": return "Mailboxes";
    case "corner-guard": return "Corner Guards";
    default: return "UNKNOWN";
} }
